import React, {useState} from "react";
import {FormProvider, useForm} from "react-hook-form";
import {Form} from "react-bootstrap";
import InfoPanel from "../../components/common/repeated-page-panels/InfoPanel";
import HorizontalFormInput from "../../components/common/horizontal-form-inputs/HorizontalFormInput";
import PractitionerLocationTitle from "./PractitionerLocationTitle";

const PractitionerLocationInfo = ({data, displayMode}) => {
    const [readMode, setReadMode] = useState(true);
    const isInFlight = false;
    const methods = useForm({
        values: {
            practitionerName: data.node.practitioner.applicableVersion.displayName,
            locationName: data.node.location.applicableVersion.name,
            lineOfServiceName: data.node.legalContractLineOfService.lineOfService.name,
            mondayHours: data.node.applicableVersion.mondayHours,
            tuesdayHours: data.node.applicableVersion.tuesdayHours,
            wednesdayHours: data.node.applicableVersion.wednesdayHours,
            thursdayHours: data.node.applicableVersion.thursdayHours,
            fridayHours: data.node.applicableVersion.fridayHours,
            saturdayHours: data.node.applicableVersion.saturdayHours,
            sundayHours: data.node.applicableVersion.sundayHours,
            acceptingNewPatients: data.node.applicableVersion.acceptingNewPatients,
            facilityWheelchairAccessible: data.node.applicableVersion.facilityWheelchairAccessible,
            requiresReferral: data.node.applicableVersion.requiresReferral,
            appointmentWaitTime: data.node.applicableVersion.appointmentWaitTime,
            effectiveFrom: data.node.applicableVersion.effectiveFrom,
            effectiveTo: data.node.applicableVersion.effectiveTo,
            showInDirectory: data.node.applicableVersion.showInDirectory,
            providesHomeVisits: data.node.applicableVersion.providesHomeVisits,
            providesOfficeVisits: data.node.applicableVersion.providesOfficeVisits,
            providesTelehealth: data.node.applicableVersion.providesTelehealth,
        }
    });

    const handleCancelClick = () => {
        setReadMode(true);
    }
    const onSubmit = () => {
    }
    return (
        <FormProvider {...methods}>
            <Form noValidate onSubmit={methods.handleSubmit(onSubmit)}>
                <InfoPanel
                    name={<PractitionerLocationTitle data={data?.node}/>}
                    readMode={readMode}
                    isInFlight={isInFlight}
                    onCancelChangesClick={handleCancelClick}
                    onUpdateDetailsClick={() => {
                        setReadMode(false)
                    }}
                    showUpdate={displayMode === "current" ? false : false}
                >
                    <HorizontalFormInput controlId={"practitionerName"}
                                         label={"Practitioner Name"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"locationName"}
                                         label={"Location Name"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"lineOfServiceName"}
                                         label={"Line of Service"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"showInDirectory"}
                                         label={"Show In Directory"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"acceptingNewPatients"}
                                         label={"Accepting New Patients"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"providesTelehealth"}
                                         label={"Provides Telehealth"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"providesOfficeVisits"}
                                         label={"Provides Office Visits"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"providesHomeVisits"}
                                         label={"Provides Home Visits"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"facilityWheelchairAccessible"}
                                         label={"Facility Wheelchair Accessible"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"requiresReferral"}
                                         label={"Requires Referral"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"appointmentWaitTime"}
                                         label={"Appointment Wait Time"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"mondayHours"}
                                         label={"Monday Hours"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"tuesdayHours"}
                                         label={"Tuesday Hours"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"wednesdayHours"}
                                         label={"Wednesday Hours"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"thursdayHours"}
                                         label={"Thursday Hours"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"fridayHours"}
                                         label={"Friday Hours"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"saturdayHours"}
                                         label={"Saturday Hours"}
                                         readMode={readMode}
                    />
                    <HorizontalFormInput controlId={"sundayHours"}
                                         label={"Sunday Hours"}
                                         readMode={readMode}
                    />
                </InfoPanel>
            </Form>
        </FormProvider>

    );

}

export default PractitionerLocationInfo;